import { http } from 'shared/api';

class ConfigAPI {
  static fetchConfig() {
    return http.get('config');
  }
}

export default ConfigAPI;
